/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：549__part-1
 */

"use strict"

import { b } from "./index"
var r
import * as /* [auto-meaningful-name] */Module_11 from /* 11 */"../11"
import * as /* [auto-meaningful-name] */Module_10 from /* 10 */"../10/index"
import /* 0 */"react"
import * as /* [auto-meaningful-name] */React from "react"
import /* [auto-meaningful-name] */React1 from /* 0 */"react"
import * as /* [auto-meaningful-name] */Color from /* 51 */"color"
import /* [auto-meaningful-name] */Color1 from /* 51 */"color"
import * as /* [auto-meaningful-name] */Classnames from /* 8 */"classnames"
import /* [auto-meaningful-name] */Classnames1 from /* 8 */"classnames"
import * as /* [auto-meaningful-name] */Src_editor_widget_builtIn_types from /* 5 */"../../../../../src/editor/widget/built-in/types"
import * as /* [auto-meaningful-name] */Module_90 from /* 90 */"../90"
import * as /* [auto-meaningful-name] */Src_shared_tools_index from /* 15 */"../../../../../src/shared/tools/index"
import * as /* [auto-meaningful-name] */Module_28 from /* 28 */"../28/index"
import * as /* [auto-meaningful-name] */Module_77 from /* 77 */"../77"
import * as /* [auto-meaningful-name] */Module_159 from /* 159 */"./159"
import /* [auto-meaningful-name] */Module_1591 from /* 159 */"./159"
!function (e) {
  e[e.DOWN = 0] = "DOWN"
  e[e.UP = 1] = "UP"
}(r || (r = {}))
if (Module_28.b() && Module_28.h()) {
  document.body.addEventListener("touchmove", function (e) {
    if (b) {
      e.preventDefault()
    }
  }, {
    passive: false
  })
}
export { r }
